// Selector.jsx - Version avec support VIDEO, PDF, JSON, JSON_RICH et EVALUATION complet avec token
import React from 'react';
import { APP_CONFIG } from '../../config/appConfig';
import FormationPdf from './FormationPdf';
import FormationJson from './FormationJson';
import FormationJsonRich from './FormationJsonRich';
import FormationVideo from './FormationVideo';
import Evaluation from './Evaluation';

export default function Selector({
    module,
    contenu,
    formationTitre,
    moduleOrdre,
    totalModules,
    isOpen,
    onClose,
    onExit,
    onModuleChange,
    onComplete,
    onSubmit,
    mode,
    userRole,
    pdfToken,
    videoToken,
    etudiantId,
    // ⭐ CORRECTION : prop manquante. Evaluation.jsx a été corrigé pour exiger
    // ce token JWT afin d'appeler correctement /modules/{id}/evaluation/demarrer
    // (header Authorization). Sans cette prop ici, Selector ne pouvait pas le
    // relayer, et toute évaluation embarquée dans une formation restait bloquée.
    token
}) {
    console.log('🔍 [Selector] === COMPOSANT RENDU ===');
    console.log('🔍 [Selector] Props reçues:', {
        moduleId: module?.id,
        type: module?.type,
        contenuType: typeof contenu,
        contenu,
        isOpen,
        mode,
        hasPdfToken: !!pdfToken,
        hasVideoToken: !!videoToken,
        userRole
    });

    if (!isOpen || !module) {
        console.log('⏭️ [Selector] Skip - isOpen:', isOpen, 'module:', !!module);
        return null;
    }

    // Déterminer le type à partir du contenu ou du module
    const determineType = () => {
        console.log('🔍 [Selector] determineType - début');
        // 1) Confiance au champ 'type' (contient typeModule)
        if (module.type) {
            console.log(`🔍 [Selector] Type depuis module.type: ${module.type}`);
            if (module.type === 'EVALUATION') return 'EVALUATION';
            if (module.type === 'VIDEO') return 'VIDEO';
            if (module.type === 'JSON_RICH') return 'JSON_RICH'; // ⭐ Ajout
            return module.type;
        }

        // 2) Indicateurs booléens
        if (module.hasPdf) return 'PDF';
        if (module.hasJsonContent) {
            // On pourrait détecter si c'est JSON_RICH, mais on s'en remet au module.type
            return 'JSON';
        }
        if (module.hasEvaluation) return 'EVALUATION';
        if (module.hasVideo || module.videoUrl || module.videoStreamUrl) return 'VIDEO';

        // 3) Contenu réel
        if (contenu && typeof contenu === 'object') {
            console.log('🔍 [Selector] Contenu est un objet');
            // Détecter JSON_RICH via la présence de champs médias (imageUrl, pdfUrl, etc.)
            // mais on garde simple : si le module n'a pas de type spécifique, on utilise JSON
            if (contenu.modules || contenu.titre) {
                console.log('🔍 [Selector] Détecté comme JSON (modules ou titre)');
                // On pourrait vérifier si un contenu contient des médias, mais on utilise le type du module
                // Si module.type n'est pas défini, on suppose JSON standard
                return 'JSON';
            }
            if (Array.isArray(contenu) && contenu.length > 0 && contenu[0].enonce) {
                console.log('🔍 [Selector] Détecté comme EVALUATION (tableau avec enonce)');
                return 'EVALUATION';
            }
            if (contenu.questions && Array.isArray(contenu.questions)) {
                console.log('🔍 [Selector] Détecté comme EVALUATION (questions)');
                return 'EVALUATION';
            }
            if (contenu.type === 'EVALUATION' || contenu.type === 'DIAGNOSTIC' || contenu.type === 'SOMMATIVE') {
                console.log(`🔍 [Selector] Détecté comme EVALUATION (type: ${contenu.type})`);
                return 'EVALUATION';
            }
        }
        if (module.evaluations && module.evaluations.length > 0) {
            console.log('🔍 [Selector] Détecté comme EVALUATION (module.evaluations)');
            return 'EVALUATION';
        }
        if (module.jsonContent) {
            console.log('🔍 [Selector] Détecté comme JSON (module.jsonContent)');
            // Si le module a un typeModule, on l'utilise, sinon JSON
            if (module.typeModule === 'JSON_RICH') return 'JSON_RICH';
            return 'JSON';
        }
        if (module.pdfStreamUrl || module.pdfUrl) {
            console.log('🔍 [Selector] Détecté comme PDF (module.pdfUrl)');
            return 'PDF';
        }
        // Détection VIDEO
        if (module.videoUrl || module.videoStreamUrl) {
            console.log('🔍 [Selector] Détecté comme VIDEO (module.videoUrl)');
            return 'VIDEO';
        }
        if (typeof contenu === 'string' && (contenu.startsWith('http') || contenu.startsWith('/') || contenu.includes('.mp4') || contenu.includes('.webm'))) {
            console.log('🔍 [Selector] Détecté comme VIDEO (URL vidéo)');
            return 'VIDEO';
        }
        console.log('🔍 [Selector] Type inconnu, retour UNKNOWN');
        return 'UNKNOWN';
    };

    const type = determineType();
    console.log('🔍 [Selector] Type détecté:', type);

    // Gestion du contenu pour chaque type
    const getPdfUrl = () => {
        console.log(`🎬 [Selector] URL pdfStreamUrl`, module.pdfStreamUrl);
        console.log(`🎬 [Selector] URL pdfUrl`, module.pdfUrl);
        if (module.pdfStreamUrl) return module.pdfStreamUrl;
        if (module.pdfUrl) return module.pdfUrl;
        if (typeof contenu === 'string' && (contenu.startsWith('http') || contenu.startsWith('/') || contenu.includes('.pdf'))) return contenu;
        return module.pdfStreamUrl || module.pdfUrl || module.streamUrl || module.url || module.pdf_stream_url || null;
    };

    // Récupération de l'URL vidéo
    const getVideoUrl = () => {
        let url = module.videoStreamUrl || module.videoUrl || module.streamUrl || module.url || module.video_url || null;

        console.log(`🎬 [Selector] URL VIDEO avant controle :`, url);
        if (typeof contenu === 'string' && (contenu.startsWith('http') || contenu.startsWith('/') || contenu.includes('.mp4') || contenu.includes('.webm'))) {
            url = contenu;
        }
        console.log(`🎬 [Selector] URL VIDEO apres controle :`, url);
        // ⭐ Ajouter le token si disponible
        if (url && videoToken && !url.includes('token=')) {
            const separator = url.includes('?') ? '&' : '?';
            url = `${url}${separator}token=${videoToken}`;
            console.log(`🎬 [Selector] Token vidéo ajouté à l'URL`, url);
        }
        console.log(`🎬 [Selector] URL VIDEO apres ajout token :`, url);
        return url;
    };

    const getJsonContent = () => {
        if (module.jsonContent) return module.jsonContent;
        if (typeof contenu === 'object' && contenu !== null && !Array.isArray(contenu)) return contenu;
        return null;
    };

    const getEvaluationData = () => {
        if (module.evaluations && module.evaluations.length > 0) {
            console.log(`📊 [Selector] getEvaluationData: module.evaluations (${module.evaluations.length})`);
            return module.evaluations;
        }
        if (Array.isArray(contenu) && contenu.length > 0) {
            console.log(`📊 [Selector] getEvaluationData: contenu tableau (${contenu.length})`);
            return contenu;
        }
        if (contenu && contenu.questions && Array.isArray(contenu.questions)) {
            console.log(`📊 [Selector] getEvaluationData: contenu.questions (${contenu.questions.length})`);
            return [contenu];
        }
        if (contenu && typeof contenu === 'object' && contenu.titre && contenu.questions) {
            console.log('📊 [Selector] getEvaluationData: objet avec titre et questions');
            return [contenu];
        }
        if (module.content && Array.isArray(module.content)) {
            console.log(`📊 [Selector] getEvaluationData: module.content (${module.content.length})`);
            return module.content;
        }
        console.warn('⚠️ [Selector] getEvaluationData: aucune donnée trouvée');
        return null;
    };

    // Si mode demo, désactiver certaines fonctionnalités
    const isDemoMode = mode === 'demo';

    // Déterminer le type d'évaluation
    const getEvalType = () => {
        if (module.evalType) return module.evalType;
        if (module.type === 'EVALUATION') return 'SOMMATIVE';
        if (contenu && contenu.type) return contenu.type;
        return 'SOMMATIVE';
    };

    // Générer un ID unique pour le module si nécessaire
    const getModuleId = () => {
        if (module.id) return module.id;
        if (module.titre) return `module-${module.titre.replace(/\s+/g, '-').toLowerCase()}`;
        return 'module-temporaire';
    };

    console.log(`🎯 [Selector] Mode: ${mode}, isDemoMode: ${isDemoMode}`);
    console.log(`🎯 [Selector] EvaluationData:`, getEvaluationData());

    // SWITCH avec tous les cas
    switch (type) {
        case 'PDF': {
            const url = getPdfUrl();
            if (!url) {
                console.warn('⚠️ [Selector] Type PDF mais aucune URL trouvée');
                return <div className="p-8 text-center text-red-500">Aucune URL PDF disponible</div>;
            }
            console.log(`📄 [Selector] Rendu PDF: ${url}`);
            return (
                <FormationPdf
                    module={module}
                    pdfUrl={url}
                    formationTitre={formationTitre}
                    moduleOrdre={moduleOrdre}
                    totalModules={totalModules}
                    isOpen={isOpen}
                    onClose={onClose}
                    onModuleChange={isDemoMode ? () => {} : onModuleChange}
                    onComplete={isDemoMode ? () => {} : onComplete}
                    onExit={onExit}
                    mode={mode || 'production'}
                    userRole={userRole || 'etudiant'}
                    pdfToken={pdfToken}
                />
            );
        }
        // Cas VIDEO
        case 'VIDEO': {
            let url = getVideoUrl();
            if (!url) {
                console.warn('⚠️ [Selector] Type VIDEO mais aucune URL trouvée');
                return <div className="p-8 text-center text-red-500">Aucune URL vidéo disponible</div>;
            }
            console.log(`🎬 [Selector] Rendu VIDEO: ${url}`);
            return (
                <FormationVideo
                    module={module}
                    videoUrl={url}
                    formationTitre={formationTitre}
                    moduleOrdre={moduleOrdre}
                    totalModules={totalModules}
                    isOpen={isOpen}
                    onClose={onClose}
                    onModuleChange={isDemoMode ? () => {} : onModuleChange}
                    onComplete={isDemoMode ? () => {} : onComplete}
                    onExit={onExit}
                    mode={mode || 'production'}
                />
            );
        }
        case 'JSON': {
            const json = getJsonContent();
            if (!json) {
                console.warn('⚠️ [Selector] Type JSON mais aucun contenu');
                return <div className="p-8 text-center text-red-500">Aucun contenu JSON disponible</div>;
            }
            console.log(`📝 [Selector] Rendu JSON`);
            return (
                <FormationJson
                    module={module}
                    jsonContent={json}
                    formationTitre={formationTitre}
                    moduleOrdre={moduleOrdre}
                    totalModules={totalModules}
                    isOpen={isOpen}
                    onClose={onClose}
                    onModuleChange={isDemoMode ? () => {} : onModuleChange}
                    onComplete={isDemoMode ? () => {} : onComplete}
                    onExit={onExit}
                    mode={mode || 'production'}
                    userRole={userRole || 'etudiant'}
                />
            );
        }
        // ⭐ NOUVEAU CAS JSON_RICH
        case 'JSON_RICH': {
            const json = getJsonContent();
            if (!json) {
                console.warn('⚠️ [Selector] Type JSON_RICH mais aucun contenu');
                return <div className="p-8 text-center text-red-500">Aucun contenu JSON disponible</div>;
            }
            console.log(`📝 [Selector] Rendu JSON_RICH`);
            return (
                <FormationJsonRich
                    module={module}
                    jsonContent={json}
                    formationTitre={formationTitre}
                    moduleOrdre={moduleOrdre}
                    totalModules={totalModules}
                    isOpen={isOpen}
                    onClose={onClose}
                    onModuleChange={isDemoMode ? () => {} : onModuleChange}
                    onComplete={isDemoMode ? () => {} : onComplete}
                    onExit={onExit}
                    mode={mode || 'production'}
                    userRole={userRole || 'etudiant'}
                    apiBase={APP_CONFIG.BASE_URL}
                />
            );
        }
        case 'EVALUATION': {
            const evalData = getEvaluationData();
            if (!evalData || evalData.length === 0) {
                console.warn('⚠️ [Selector] Type EVALUATION mais aucune donnée');
                return <div className="p-8 text-center text-red-500">Aucune évaluation disponible</div>;
            }

            const moduleWithId = {
                ...module,
                id: getModuleId()
            };
            // Déterminer evaluationId : si le module a un champ evaluationId, l'utiliser, sinon utiliser module.id
            const evalId = module.evaluationId || module.id;

            console.log(`📊 [Selector] Rendu EVALUATION - ${evalData.length} questions`);
            console.log(`📊 [Selector] evalType: ${getEvalType()}`);
            console.log(`📊 [Selector] moduleWithId:`, moduleWithId);

            return (
                <Evaluation
                    module={moduleWithId}
                    evaluationData={evalData}
                    formationTitre={formationTitre || module.titre || 'Évaluation'}
                    moduleOrdre={moduleOrdre || 1}
                    totalModules={totalModules || 1}
                    isOpen={isOpen}
                    onClose={onClose}
                    onComplete={isDemoMode ? () => {} : onComplete}
                    onSubmit={isDemoMode ? () => {} : onSubmit}
                    onExit={onExit}
                    evalType={getEvalType()}
                    userRole={userRole || 'etudiant'}
                    mode={mode || 'production'}
                    evaluationId={evalId}
                    moduleId={module.id}
                    etudiantId={etudiantId}
                    // ⭐ CORRECTION : requis pour l'appel interne /demarrer
                    token={token}
                />
            );
        }
        default:
            console.warn('⚠️ [Selector] Type inconnu:', type, module);
            return (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80">
                    <div className="bg-white p-8 rounded-xl max-w-md">
                        <h3 className="text-lg font-bold text-red-600">Type de module non pris en charge</h3>
                        <p className="text-gray-600">Type détecté : {type}</p>
                        <p className="text-gray-600 text-sm">Module: {module.titre || 'Sans titre'}</p>
                        <button onClick={onClose} className="mt-4 px-4 py-2 bg-gray-700 text-white rounded">Fermer</button>
                    </div>
                </div>
            );
    }
}